import React from "react";

import { agentLaunchCapabilities } from "./agentLaunchCopy";
import { BetaIntroVideo } from "./components/BetaIntroVideo";

export function AgentLaunchOverview() {
  return (
    <div className="flex flex-col gap-4 text-default">
      <BetaIntroVideo />
      <div className="flex flex-col gap-3">
        <h2 className="m-0 font-archivo text-xl font-semibold leading-tight text-default">
          Introducing the new version of Replo
        </h2>
        <ul className="m-0 flex list-disc flex-col gap-2 pl-5 text-sm text-muted marker:text-orange">
          {agentLaunchCapabilities.slice(0, 4).map((capability) => (
            <li key={capability.title} className="pl-1 leading-snug">
              <strong className="font-archivo font-medium text-default">
                {capability.title}
              </strong>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
